export default class PageFrom {
  constructor(tagKey) {
    this.tagKey = tagKey || 'or-page-from'
  }

  markePage(tag) {
    localStorage.setItem(this.tagKey, tag)
  }

  getPageFrom() {
    return localStorage.getItem(this.tagKey)
  }

  clear() {
    localStorage.removeItem(this.tagKey)
  }
}
